import { Vob } from '@finpay-estimation/estimation-types';

interface VobSource {
    vobSourceId: number;
    name: string;
}

interface Facility {
    facilityId: number;
    facilityName: string;
}

interface Patient {
    contact?: {
        firstName?: string;
        lastName?: string;
    };
}

/**
 * Formats a date string to YYYY-MM-DD format
 */
const formatVobDate = (dateString: string | undefined): string => {
    if (!dateString) return '';
    return dateString.split('T')[0];
};

/**
 * Gets VOB source name by ID from the vobSources array
 */
const getVobSourceName = (vobSourceId: number | undefined, vobSources: VobSource[]): string => {
    if (!vobSourceId) return '';
    const vobSource = vobSources.find(source => source.vobSourceId === vobSourceId);
    return vobSource?.name || vobSourceId.toString();
};

/**
 * Gets facility name by ID from the facilities array
 */
const getFacilityName = (facilityId: number | undefined, facilities: Facility[]): string => {
    if (!facilityId) return '';
    const facility = facilities.find(f => f.facilityId === facilityId);
    return facility ? facility.facilityName : '';
};

/**
 * Generates the display text for a VOB item in selectors/lists
 */
export const generateVobDisplayText = (
    vob: Vob,
    patient: Patient | null,
    vobSources: VobSource[],
    facilities: Facility[]
): string => {
    const livePrefix = vob.liveVOB ? 'Live ' : '';
    const sourceName = getVobSourceName(vob?.vobSourceId, vobSources || []);
    const patientName = `${patient?.contact?.firstName || ''} ${patient?.contact?.lastName || ''}`.trim();
    const formattedDate = formatVobDate(vob?.createDt);
    const facilityName = getFacilityName(vob?.facility?.facilityId, facilities || []);
    const payorName = vob?.payor?.facilityPayorName || vob?.payor?.payorName || '';
    const planName = vob?.plan?.facilityPlanName || vob?.plan?.planName || '';

    return `${livePrefix}${sourceName} ${patientName} ${formattedDate} ${facilityName} ${payorName} ${planName}`.replace(/\s+/g, ' ').trim();
}; 